
(function() {
  var result = { translations: { "en": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanian", "sq-al": "Albanian - Albania", "ar": "Arabic", "ar-dz": "Arabic - Algeria", "ar-bh": "Arabic - Bahrain", "ar-eg": "Arabic - Egypt", "ar-iq": "Arabic - Iraq", "ar-jo": "Arabic - Jordan", "ar-kw": "Arabic - Kuwait", "ar-lb": "Arabic - Lebanon", "ar-ly": "Arabic - Libya", "ar-ma": "Arabic - Morocco", "ar-om": "Arabic - Oman", "ar-qa": "Arabic - Qatar", "ar-sa": "Arabic - Saudi Arabia", "ar-sd": "Arabic - Sudan", "ar-sy": "Arabic - Syria", "ar-tn": "Arabic - Tunisia", "ar-ae": "Arabic - United Arab Emirates", "ar-ye": "Arabic - Yemen", "as": "Assamese", "az": "Azerbaijani", "hy": "Armenian", "eu": "Basque", "be": "Belarusian", "be-by": "Belarusian - Belarus", "bn": "Bengali", "bg": "Bulgarian", "bg-bg": "Bulgarian - Bulgaria", "ca": "Catalan", "ca-es": "Catalan - Catalan", "zh": "Chinese", "zh-cn": "Chinese - Simplified", "zh-hk": "Chinese - Hong Kong", "zh-mo": "Chinese - Macau", "zh-sg": "Chinese - Singapore", "zh-tw": "Chinese - Traditional", "zh-chs": "Chinese (Simplified)", "zh-cht": "Chinese (Traditional)", "zh-hans": "Chinese (Simplified Han)", "zh-hant": "Chinese (Traditional Han)", "hr": "Croatian", "hr-hr": "Croatian - Croatia", "cs": "Czech", "cs-cz": "Czech - Czech Republic", "da": "Danish", "da-dk": "Danish - Denmark", "nl": "Dutch", "nl-be": "Dutch - Belgium", "nl-ch": "Dutch - Switzerland", "nl-lu": "Dutch - Luxembourg", "nl-nl": "Dutch - The Netherlands", "en": "English", "en-ae": "English - United Arab Emirates", "en-au": "English - Australia", "en-be": "English - Belgium", "en-ca": "English - Canada", "en-ch": "English - Switzerland", "en-cn": "English - China", "en-de": "English - Germany", "en-ee": "English - Estonia", "en-fr": "English - France", "en-hk": "English - Hong Kong", "en-in": "English - India", "en-ie": "English - Ireland", "en-ke": "English - Kenya", "en-lu": "English - Luxembourg", "en-my": "English - Malaysia", "en-mt": "English - Malta", "en-mx": "English - Mexico", "en-nl": "English - The Netherlands", "en-nz": "English - New Zealand", "en-ph": "English - Philippines", "en-pk": "English - Pakistan", "en-se": "English - Sweden", "en-sg": "English - Singapore", "en-za": "English - South Africa", "en-gb": "English - United Kingdom", "en-us": "English - United States", "en-zw": "English - Zimbabwe", "et": "Estonian", "et-ee": "Estonian - Estonia", "fo": "Faroese", "fa": "Farsi", "fi": "Finnish", "fi-fi": "Finnish - Finland", "fil": "Filipino", "fr": "French", "fr-be": "French - Belgium", "fr-ca": "French - Canada", "fr-fr": "French - France", "fr-lu": "French - Luxembourg", "fr-mc": "French - Monaco", "fr-ch": "French - Switzerland", "fr-tn": "French - Tunisia", "gl": "Galician", "ka": "Georgian", "de": "German", "de-at": "German - Austria", "de-de": "German - Germany", "de-gr": "German - Greece", "de-li": "German - Liechtenstein", "de-lu": "German - Luxembourg", "de-ch": "German - Switzerland", "el": "Greek", "el-cy": "Greek - Cyprus", "el-gr": "Greek - Greece", "gu": "Gujarati", "ha": "Hausa", "he": "Hebrew", "he-il": "Hebrew - Israel", "iw-il": "Hebrew - Israel", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Hungarian", "hu-hu": "Hungarian - Hungary", "is": "Icelandic", "is-is": "Icelandic - Iceland", "id": "Indonesian", "in-id": "Indonesian - Indonesia", "ga": "Irish", "ga-ie": "Irish - Ireland", "it": "Italian", "it-it": "Italian - Italy", "it-ch": "Italian - Switzerland", "ja": "Japanese", "ja-jp": "Japanese - Japan", "kn": "Kannada", "kk": "Kazakh", "kok": "Konkani", "ko": "Korean", "ko-kr": "Korean - South Korea", "ky": "Kyrgyz", "ky-kg": "Kyrgyz", "lo": "Lao", "lv": "Latvian", "lv-lv": "Latvian - Latvia", "lt": "Lithuanian", "lt-lt": "Lithuanian - Lithuania", "mk": "Macedonian", "mk-mk": "Macedonian - Macedonia", "ml": "Malayalam", "ms": "Malay", "ms-bn": "Malay - Brunei", "ms-my": "Malay - Malaysia", "mt": "Maltese", "mt-mt": "Maltese - Malta", "mr": "Marathi", "mn": "Mongolian", "my": "Burmese", "my-mm": "Burmese - Myanmar (Burma)", "ne": "Nepali", "no": "Norwegian", "nb": "Norwegian Bokmal", "nb-no": "Norwegian Bokmal - Norway", "no-no": "Norwegian - Norway", "pl": "Polish", "pl-pl": "Polish - Poland", "pt": "Portuguese", "pt-br": "Portuguese - Brazil", "pt-pt": "Portuguese - Portugal", "pa": "Punjabi", "pa-in": "Punjabi - India", "pa-pk": "Punjabi - Pakistan", "ro": "Romanian", "ro-ro": "Romanian - Romania", "ru": "Russian", "ru-ru": "Russian - Russia", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Sinhala", "sr": "Serbian", "sr-ba": "Serbian - Bosnia and Herzegovina", "sr-me": "Serbian - Montenegro", "sr-rs": "Serbian - Serbia", "sr-cs": "Serbian - Serbia and Montenegro (Former)", "sk": "Slovak", "sk-sk": "Slovak - Slovakia", "sl": "Slovenian", "sl-si": "Slovenian - Slovenia", "es": "Spanish", "es-ar": "Spanish - Argentina", "es-bo": "Spanish - Bolivia", "es-cl": "Spanish - Chile", "es-co": "Spanish - Colombia", "es-cr": "Spanish - Costa Rica", "es-cu": "Spanish - Cuba", "es-do": "Spanish - Dominican Republic", "es-ec": "Spanish - Ecuador", "es-sv": "Spanish - El Salvador", "es-gt": "Spanish - Guatemala", "es-hn": "Spanish - Honduras", "es-mx": "Spanish - Mexico", "es-ni": "Spanish - Nicaragua", "es-pa": "Spanish - Panama", "es-py": "Spanish - Paraguay", "es-pe": "Spanish - Peru", "es-pr": "Spanish - Puerto Rico", "es-es": "Spanish - Spain", "es-us": "Spanish - United States", "es-uy": "Spanish - Uruguay", "es-ve": "Spanish - Venezuela", "sw": "Swahili", "sv": "Swedish", "sv-fi": "Swedish - Finland", "sv-se": "Swedish - Sweden", "sy": "Syriac", "ta": "Tamil", "tt": "Tatar", "te": "Telugu", "th": "Thai", "th-th": "Thai - Thailand", "tl": "Tagalog", "tr": "Turkish", "tr-tr": "Turkish - T\xFCrkiye", "uk": "Ukrainian", "uk-ua": "Ukrainian - Ukraine", "ur": "Urdu", "uz": "Uzbek", "vi": "Vietnamese", "vi-vn": "Vietnamese - Vietnam", "yi": "Yiddish", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.150",
    "ar-eg": "static-1.150",
    "ar-sa": "static-1.150",
    "ar": "static-1.150",
    "be": "static-1.150",
    "bg": "static-1.150",
    "bn": "static-1.150",
    "ca-es": "static-1.150",
    "ca": "static-1.150",
    "cs": "static-1.150",
    "da": "static-1.150",
    "de": "static-1.150",
    "el": "static-1.150",
    "en-gb": "static-1.150",
    "en": "static-1.150",
    "es-ar": "static-1.150",
    "es-es": "static-1.150",
    "es-mx": "static-1.150",
    "es": "static-1.150",
    "et": "static-1.150",
    "eu": "static-1.150",
    "fi": "static-1.150",
    "fr-ca": "static-1.150",
    "fr": "static-1.150",
    "gl": "static-1.150",
    "gu": "static-1.150",
    "he-il": "static-1.150",
    "he": "static-1.150",
    "hi": "static-1.150",
    "hr": "static-1.150",
    "hu": "static-1.150",
    "hy": "static-1.150",
    "id": "static-1.150",
    "is": "static-1.150",
    "it": "static-1.150",
    "ja": "static-1.150",
    "ka": "static-1.150",
    "kk": "static-1.150",
    "kn": "static-1.150",
    "ko": "static-1.150",
    "ky": "static-1.150",
    "lt": "static-1.150",
    "lv": "static-1.150",
    "mk": "static-1.150",
    "mn": "static-1.150",
    "mr": "static-1.150",
    "ms-my": "static-1.150",
    "ms": "static-1.150",
    "nl-be": "static-1.150",
    "nl-nl": "static-1.150",
    "nl": "static-1.150",
    "no": "static-1.150",
    "pl": "static-1.150",
    "pt-br": "static-1.150",
    "pt-pt": "static-1.150",
    "ro": "static-1.150",
    "ru": "static-1.150",
    "sk": "static-1.150",
    "sl": "static-1.150",
    "sq": "static-1.150",
    "sr": "static-1.150",
    "sv": "static-1.150",
    "sw": "static-1.150",
    "ta": "static-1.150",
    "te": "static-1.150",
    "th": "static-1.150",
    "tl": "static-1.150",
    "tr": "static-1.150",
    "uk": "static-1.150",
    "ur": "static-1.150",
    "vi": "static-1.150",
    "zh-cn": "static-1.150",
    "zh-hans": "static-1.150",
    "zh-hant": "static-1.150",
    "zh-hk": "static-1.150",
    "zh-tw": "static-1.150"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1098"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1098",
    "ar-eg": "static-7.1098",
    "bg": "static-7.1098",
    "bn": "static-7.1098",
    "ca-es": "static-7.1098",
    "cs": "static-7.1098",
    "da": "static-7.1098",
    "de": "static-7.1098",
    "el": "static-7.1098",
    "en-gb": "static-7.1098",
    "en": "static-7.1098",
    "es-mx": "static-7.1098",
    "es": "static-7.1098",
    "et": "static-7.1098",
    "fi": "static-7.1098",
    "fr-ca": "static-7.1098",
    "fr": "static-7.1098",
    "he-il": "static-7.1098",
    "hi": "static-7.1098",
    "hr": "static-7.1098",
    "hu": "static-7.1098",
    "id": "static-7.1098",
    "it": "static-7.1098",
    "ja": "static-7.1098",
    "ko": "static-7.1098",
    "lt": "static-7.1098",
    "ms": "static-7.1098",
    "nl": "static-7.1098",
    "no": "static-7.1098",
    "pl": "static-7.1098",
    "pt-br": "static-7.1098",
    "pt-pt": "static-7.1098",
    "ro": "static-7.1098",
    "ru": "static-7.1098",
    "sk": "static-7.1098",
    "sl": "static-7.1098",
    "sv": "static-7.1098",
    "th": "static-7.1098",
    "tl": "static-7.1098",
    "tr": "static-7.1098",
    "uk": "static-7.1098",
    "vi": "static-7.1098",
    "x-pseudo": "static-7.1098",
    "zh-cn": "static-7.1098",
    "zh-hk": "static-7.1098",
    "zh-tw": "static-7.1098"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1098'}); }
})();



(function() {
  var result = { translations: { "en": { "videoPlayer": { "htmlTitle": "HubSpot Video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Audio player", "videoPlayer": "Video player", "play": "Play", "playVideo": "Play video", "pause": "Pause", "replay": "Replay", "currentTime": "Current time", "duration": "Duration", "remainingTime": "Remaining time", "fullscreen": "Fullscreen", "exitFullscreen": "Exit Fullscreen", "mute": "Mute", "unmute": "Unmute", "volumeLevel": "Volume level", "captions": "Subtitles", "captionsOff": "Off" }, "playbackOptions": { "buttonTitle": "Playback options", "playbackRate": "Playback speed:", "quality": "Quality:", "normal": "Normal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Thanks for your response!", "inlineMessageButton": "Watch video" }, "ctaModal": { "imgAlt": "Video CTA" }, "errors": { "generic": { "heading": "Could not load video" }, "UNAUTHORIZED": { "heading": "Video not enabled" }, "VIDEO_NOT_FOUND": { "heading": "Video not found" }, "INVALID_URL": { "heading": "Video not found" }, "UNSUPPORTED_EMBED": { "heading": "Video not available", "extra": "This video can't be viewed externally." }, "refreshLink": "Try again" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "en": "static-1.18313"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.18313",
    "ar-eg": "static-1.18313",
    "bg": "static-1.18313",
    "bn": "static-1.18313",
    "ca-es": "static-1.18313",
    "cs": "static-1.18313",
    "da": "static-1.18313",
    "de": "static-1.18313",
    "el": "static-1.18313",
    "en-gb": "static-1.18313",
    "en": "static-1.18313",
    "es-mx": "static-1.18313",
    "es": "static-1.18313",
    "et": "static-1.18313",
    "fi": "static-1.18313",
    "fr-ca": "static-1.18313",
    "fr": "static-1.18313",
    "he-il": "static-1.18313",
    "hi": "static-1.18313",
    "hr": "static-1.18313",
    "hu": "static-1.18313",
    "id": "static-1.18313",
    "it": "static-1.18313",
    "ja": "static-1.18313",
    "ko": "static-1.18313",
    "lt": "static-1.18313",
    "ms": "static-1.18313",
    "nl": "static-1.18313",
    "no": "static-1.18313",
    "pl": "static-1.18313",
    "pt-br": "static-1.18313",
    "pt-pt": "static-1.18313",
    "ro": "static-1.18313",
    "ru": "static-1.18313",
    "sk": "static-1.18313",
    "sl": "static-1.18313",
    "sv": "static-1.18313",
    "th": "static-1.18313",
    "tl": "static-1.18313",
    "tr": "static-1.18313",
    "uk": "static-1.18313",
    "vi": "static-1.18313",
    "zh-cn": "static-1.18313",
    "zh-hk": "static-1.18313",
    "zh-tw": "static-1.18313"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:en', {version: 'static-1.18313'}); }
})();


